import { FormsModule } from '@angular/forms';
import { injectUrlViewState } from '../../../utils/url-view-state.util';
import { Component, inject, OnInit } from '@angular/core';
import { ControlsComponent } from './controls/controls.component';
import { InsightsComponent } from './insights/insights.component';
import { SearchComponent } from './search/search.component';
import { PaginationComponent } from './pagination/pagination.component';
import { TagsComponent } from './tags/tags.component';
import { ItemsComponent } from './items/items.component';
import { dummy_menus, dummy_stats, dummy_tags } from '../../../services/dummy.data';
import { Menu } from '../../../models/menu';
import { Insight } from '../../../models/insight';
import { Tag } from '../../../models/controls';
import { MenuService } from '../../../services/menu.service';
import { StationService } from '../../../services/station.service';
import { FNFResponse } from '../../../models/response';
import { ConfigService } from '../../../services/config.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from '../../controls/fnf-confirmation/confirmation-dialog/confirmation-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RestaurantService } from '../../../services/restaurant.service';
import { isPosManaged, POS_PROVIDER_NAMES } from '../../../utils/pos-provider.util';

@Component({
  selector: 'app-menus',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTooltipModule],
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.css',
})
export class MenusComponent implements OnInit {
  // menus: Menu[] = dummy_menus;
  // insights: Insight[] = dummy_stats;
  tags: Tag[] = dummy_tags;
  tagMap: Map<string, Tag> = new Map();
  menuService = inject(MenuService);
  stationService = inject(StationService);
  ngxSpinnerService = inject(NgxSpinnerService);
  configService = inject(ConfigService);
  isSidebarExpanded: boolean = true;
  selectedStatus: string = 'published';
  restaurantService = inject(RestaurantService);
  currentRestaurant: any;
  //   options = ['Main Category', 'Cuisine Type', 'South Indian', 'North Indian'];
  options: any = [];

  selectedOption: string | null = null;
  selectedOptionId: string | null = null;
  selectedCategoryId: string | null = null;
  selectedCategoryCount: any = null;

  allCategories = [
    { id: 1, name: 'All Menu', count: 0, isActive: true },
    // { name: 'Breakfast', count: 13, isActive: false },
  ];

  menus: any = [];
  filteredMenus: any = [];
  unCategoriesMenu: any = [];
  menusOriginal: any = [];
  stations: any = [];

  items = Array.from({ length: 120 }, (_, i) => `Item #${i + 1}`);
  itemsPerPage = 10;
  currentPage = 1;
  defaultView = 'Large Grid'; // Large Grid , Table
  /** Status tab, menu type and category live in the URL (?status, ?type,
   * ?category), so a browser reload reopens the same list. "View as" stays a
   * saved preference (localStorage menuView). */
  private urlState = injectUrlViewState();
  isCheckAllMenu: boolean = false;
  isSelectedMenuCount: number = 0;
  showSelectAllActions: boolean = false;
  displayLoading: boolean = false;
  searchText: string = '';
  user: any;
  restaurantPosProvider: string = 'fnf';

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private toastr: ToastrService,
  ) {
    if (localStorage.getItem('user')) {
      let user: any = localStorage.getItem('user');
      if (user) {
        this.user = JSON.parse(user);
      }
    }
    if (this.user && this.user.restaurant_id == null) {
      localStorage.removeItem('userToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      this.router.navigate(['login']);
      return;
    }
    this.getStations();
  }

  ngOnInit() {
    this.restaurantService.currentRestaurantDetails$.subscribe((restaurant: any) => {
      this.currentRestaurant = restaurant;
      this.applyDefaultTypeIfLate();
    });
    this.restaurantService.restaurantPosProvider$.subscribe((posProvider: any) => {
      this.restaurantPosProvider = posProvider;
      this.applyDefaultTypeIfLate();
    });
    this.isSidebarExpanded = this.configService.isSidebarExpanded$.value;
    // Load saved view from localStorage, fallback to default if not found
    const savedView = localStorage.getItem('menuView');
    this.defaultView = savedView || 'Large Grid';
    this.getMenusByStatus(
      this.urlState.pick('status', ['published', 'draft', 'archived'], 'published'),
    );
    // this.selectedOption = 'Main Category';
  }

  /**
   * On a fresh load the menus can arrive before the restaurant details or POS
   * provider, so the page fell back to the first type. When they land, switch
   * to the preferred type unless the URL names a type (a reload of one the
   * user picked, or of a category under it).
   */
  private applyDefaultTypeIfLate(): void {
    if (!this.options?.length || this.urlState.get('type')) return;
    const option = this.getPreferredType();
    if (option && option.id !== this.selectedOptionId) this.onSelect(option, false);
  }

  /**
   * The type the page opens on when the URL names none. Each POS sync files
   * its catalogue under a type named after the provider ("Clover", "Square",
   * "Swirepay"), but switching provider leaves the old type (e.g. "Main Type")
   * flagged as the default — so a POS-managed restaurant opens on its
   * provider's type. Otherwise the restaurant's default type, skipping one
   * left behind by a POS it no longer uses, then the first type.
   */
  private getPreferredType(): any {
    const provider = (this.restaurantPosProvider || '').toLowerCase();
    const byName = (name: string) =>
      this.options.find((o: any) => (o.name || '').toLowerCase() === name.toLowerCase());
    const otherPosTypeNames = Object.entries(POS_PROVIDER_NAMES)
      .filter(([key]) => isPosManaged(key) && key !== provider)
      .map(([, name]) => name.toLowerCase());
    const isOtherPosType = (o: any) => otherPosTypeNames.includes((o?.name || '').toLowerCase());

    if (isPosManaged(provider)) {
      const providerType = byName(POS_PROVIDER_NAMES[provider] || '');
      if (providerType) return providerType;
    }
    const defaultType = this.currentRestaurant?.types?.find((t: any) => t.is_default);
    const defaultOption = defaultType && this.options.find((o: any) => o.id == defaultType.id);
    if (defaultOption && !isOtherPosType(defaultOption)) return defaultOption;
    return this.options.find((o: any) => !isOtherPosType(o)) || defaultOption || this.options[0];
  }

  /** `fromUser` false: the page picked the type itself (after a load), so the
   * URL keeps whatever type it already names. */
  onSelect(option: any, fromUser = true): void {
    if (!option) {
      return;
    }
    if (fromUser) this.urlState.set('type', option.id);

    this.selectedOption = option.name;
    this.selectedOptionId = option.id;
    this.allCategories = option.categories || [];
    this.searchText = '';

    const allMenuCategory = this.allCategories.find((c: any) => c.name === 'All Menu');
    if (allMenuCategory) {
      allMenuCategory.count = this.getMenusForSelectedType().length;
      this.onCategorySelect(allMenuCategory);
    } else {
      const typeMenus = this.getMenusForSelectedType();
      this.menus = typeMenus;
      this.filteredMenus = typeMenus;
    }
  }

  /** Menus belonging to the currently selected type.. */
  private getMenusForSelectedType(): any[] {
    if (!this.selectedOptionId) {
      return [];
    }

    return this.menusOriginal.filter((menu: any) => menu.typeIds?.includes(this.selectedOptionId));
  }

  onCategorySelect(category: any) {
    if (!this.selectedOptionId) {
      return;
    }

    this.searchText = '';
    this.selectedCategoryId = category.id;
    if (category.name === 'All Menu') {
      this.urlState.set('category', null);
    } else {
      // A category belongs to a type: the URL names both, so a reload finds
      // it under the same type even when that was the restaurant's default.
      this.urlState.set('type', this.selectedOptionId);
      this.urlState.set('category', category.id);
    }
    this.selectedCategoryCount = category.count;

    const typeMenus = this.getMenusForSelectedType();
    let findMenus: any[] = [];

    if (category.name === 'All Menu') {
      findMenus = typeMenus;
    } else {
      findMenus = typeMenus.filter((menu: any) => {
        const menuType = menu.types?.find((t: any) => t.id === this.selectedOptionId);
        return menuType?.categories?.some((c: any) => c.id === category.id);
      });
    }

    this.menus = findMenus;
    this.filteredMenus = findMenus;

    this.allCategories.forEach((c: any) => {
      c.isActive = c.id === category.id;
    });
  }

  public getMenusByStatus(status?: any) {
    this.selectedStatus = status;
    this.urlState.set('status', status, 'published');
    this.selectedOption = null;
    this.isCheckAllMenu = false;
    this.menus = [];
    this.unCategoriesMenu = [];
    this.menusOriginal = [];
    this.allCategories = [];
    this.options = [];
    this.displayLoading = true;
    this.allCategories.push({ id: 1, name: 'All Menu', count: 0, isActive: true });
    this.menuService.getMenusByStatus(status).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data) {
          console.log('No data found');
          this.displayLoading = false;
          return;
        }
        this.menus = response.data.menus;
        let allUnCategoriesCount = 0;
        this.menusOriginal = response.data.menus;
        this.menus.forEach((e: any) => {
          e.categories = [];
          e.categoryIds = [];
          e.typeIds = [];
          e.types.forEach((f: any) => {
            if (f.categories.length > 0) {
              f.categories.forEach((c: any) => {
                e.categories.push(c.name);
                e.categoryIds.push(c.id);
              });
              e.typeIds.push(f.id);
            }
          });
          if (e.categories.length == 0) {
            this.unCategoriesMenu.push(e);
            allUnCategoriesCount += 1;
          }
          if (e.station_id) {
            let findStationName = this.stations.find((s: any) => s.station_id == e.station_id);
            e.stationName = findStationName?.station_name;
          }
        });
        let allMenuCount = 0;

        if (response.data.types) {
          response.data.types.forEach((e: any) => {
            let allTypeMenuCount = 0;
            if (e.categories.length > 0) {
              this.options.push({ id: e.id, name: e.name, categories: e.categories });
              e.categories.forEach((c: any) => {
                this.allCategories.push({
                  id: c.id,
                  name: c.name,
                  count: c.count,
                  isActive: false,
                });
                // allTypeCategories.push({ id: c.id, name: c.name, count: c.count, isActive: false });
                allMenuCount += c.count;
                allTypeMenuCount += c.count;
              });
              // e.categories should be sort by name in ascending order
              e.categories.sort((a: any, b: any) => a.name.localeCompare(b.name));
              e.categories.unshift({
                id: 1,
                name: 'All Menu',
                count: allTypeMenuCount,
                isActive: true,
              });
            }
          });
          this.allCategories[0].count = this.menus.length;
          this.allCategories[1].count = allUnCategoriesCount;
        }
        // The type and category the URL names win over the restaurant's
        // default type; read both before onSelect resets the category.
        const urlType = this.options.find((o: any) => o.id == this.urlState.get('type'));
        const urlCategoryId = this.urlState.get('category');
        this.onSelect(urlType || this.getPreferredType(), false);
        const urlCategory = this.allCategories.find((c: any) => c.id == urlCategoryId);
        if (urlCategoryId && urlCategory) {
          this.onCategorySelect(urlCategory);
        }
        this.displayLoading = false;
        // this.extractCategories()
      },
      error: (error) => {
        this.displayLoading = false;
      },
    });
  }

  editMenu(menu: any) {
    this.router.navigate(['/main/update-menu', menu.menu_id]);
  }

  openDeleteConfirmation(menu: any) {
    if (this.isPosManaged) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message:
          'This will permanently delete the ' + menu.name + ' and you can’t undo this later.',
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel',
        },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.ngxSpinnerService.show();
        this.menuService.deleteMenu(menu.menu_id).subscribe({
          next: (response: FNFResponse<any>) => {
            if (!response.data && response.error) {
              this.toastr.error(response.error.error?.message || response.error.message, 'Error');
              this.ngxSpinnerService.hide();
              return;
            } else if (!response.data) {
              this.toastr.error('No data found!', 'Error');
              this.ngxSpinnerService.hide();
              return;
            }
            let findMenuIndex = this.menus.findIndex((f: any) => menu.menu_id == f.menu_id);
            this.menus.splice(findMenuIndex, 1);
            this.ngxSpinnerService.hide();
            this.toastr.success(response.data.message, 'Success');
          },
          error: (error) => {
            this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
            this.ngxSpinnerService.hide();
          },
        });
      }
    });
  }

  deleteMenu(menu: any) {
    this.openDeleteConfirmation(menu);
  }

  get paginatedItems() {
    // const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    // return this.menus.slice(startIndex, startIndex + this.itemsPerPage);
    return this.menus;
  }

  get totalPages() {
    return Math.ceil(this.menus.length / this.itemsPerPage);
  }

  changePage(page: number) {
    this.currentPage = page;
  }

  changeItemsPerPage(count: number) {
    this.itemsPerPage = count;
    this.currentPage = 1; // Reset to the first page
  }

  changeMenuView(view: string) {
    this.defaultView = view;
    // Save the selected view to localStorage
    localStorage.setItem('menuView', view);
    this.isCheckAllMenu = false;
    this.paginatedItems.map((m: any) => (m.isSelected = false));
  }

  onMenuCheckboxChange(event: Event, menu: any, index: number) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.paginatedItems[index].isSelected = true;
    } else {
      this.paginatedItems[index].isSelected = false;
      this.isCheckAllMenu = false;
    }

    if (this.paginatedItems.length == this.paginatedItems.filter((f: any) => f.isSelected).length) {
      this.isCheckAllMenu = true;
    }

    this.isSelectedMenuCount = this.paginatedItems.filter((f: any) => f.isSelected).length;
  }

  onAllMenuCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.paginatedItems.map((m: any) => (m.isSelected = true));
      this.isCheckAllMenu = true;
    } else {
      this.paginatedItems.map((m: any) => (m.isSelected = false));
      this.isCheckAllMenu = false;
    }
    this.isSelectedMenuCount = this.paginatedItems.filter((f: any) => f.isSelected).length;
  }

  quickEditMenu(isShowQuickContent: boolean) {
    this.showSelectAllActions = isShowQuickContent;
  }

  /** Availability is POS-owned once a restaurant connects Square/Clover. */
  get isPosManaged(): boolean {
    return isPosManaged(this.restaurantPosProvider);
  }

  stockChange(isStockAvailable: boolean) {
    if (this.isPosManaged) {
      return;
    }
    let selectedMenus = this.paginatedItems.filter((f: any) => f.isSelected);
    let updatePayload: any = [];
    if (selectedMenus.length > 0) {
      selectedMenus.forEach((menu: any) => {
        updatePayload.push({ menu_id: menu.menu_id, is_available: isStockAvailable });
      });
    }

    let payload: any = { updates: updatePayload };

    this.updateBulkMenuAvailability(payload, true);
  }

  updateBulkMenuAvailability(updatePayload: any, isBulkEdit: boolean) {
    this.ngxSpinnerService.show();
    this.menuService.menuStockChanges(updatePayload).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
        } else {
          this.toastr.success('Menu availability updated successfully', 'Success');
          if (isBulkEdit) {
            this.getMenusByStatus(this.selectedStatus);
            // this.paginatedItems.map((m:any) => m.isSelected = false);
            this.isCheckAllMenu = false;
            this.quickEditMenu(false);
          } else {
            let findMenu = this.paginatedItems.find(
              (m: any) => m.menu_id == updatePayload.updates[0].menu_id,
            );
            if (findMenu) {
              findMenu.is_available = updatePayload.updates[0].is_available;
            }
          }
        }
        this.ngxSpinnerService.hide();
      },
      error: () => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.ngxSpinnerService.hide();
      },
    });
  }

  getStations() {
    this.displayLoading = true;
    this.stationService.getStations().subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
          this.displayLoading = false;
          return;
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
          this.displayLoading = false;
          return;
        }
        this.stations = response.data;
        this.setStationNameForMenus();
        this.displayLoading = false;
      },
      error: () => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.displayLoading = false;
      },
    });
  }

  setStationNameForMenus() {
    this.menus.forEach((menu: any) => {
      if (!menu.stationName) {
        if (menu.station_id) {
          const findStationName = this.stations.find((s: any) => s.station_id == menu.station_id);
          menu.stationName = findStationName ? findStationName.station_name : 'N/A';
        }
      }
    });
  }

  searchMenus(event: any) {
    this.searchText = event.target.value.toLowerCase();
    this.menus = this.filteredMenus.filter((f: any) =>
      f.name.toLowerCase().includes(this.searchText),
    );
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/default/nomenu.png';
  }

  toggleMenuAvailability(menu: any, event: any) {
    if (this.isPosManaged) {
      return;
    }
    let updatePayload: any = [];
    updatePayload.push({ menu_id: menu.menu_id, is_available: event.target.checked });

    let payload: any = { updates: updatePayload };

    this.updateBulkMenuAvailability(payload, false);
  }
}
